import React, { useEffect, useRef, useState } from "react";
import { Formik, FieldArray } from "formik";
import * as yup from "yup";
import { useNavigate, useLocation } from "react-router-dom";
import moment from "moment";
import Common from "../../helper/common";
import { Swiper, SwiperSlide } from "swiper/react";
import { Plus, X } from "lucide-react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation } from "swiper/modules";
import {
  FormikInput,
  FormikTextArea,
  FormikUploaderMultipleCarousel,
  FormikDate,
  FormikSwitch,
  FormikSelect,
  FormikSearchSelect,
  FormikSingleFileUpload,
  FormikSingleWithMultiUploadInAPage,
  FormikMultiWithSingleUploadInAPage,
} from "../../components/formik-components";
import { Button } from "../../components/ui/button";
import { StarRating } from "../../components/ui/starRating";
import { Card, CardContent } from "../../components/ui/card";
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "../../components/ui/tabs";
import { Icon } from "@iconify/react";
import TimingsCard from "../../components/cards/timingsCard";
import FacilitiesCard from "../../components/cards/facilitiesCard";
import {
  ClubPrivacyTypeEnum,
  DayOfWeekEnum,
  ImageFolderEnum,
} from "../../constants/appConstant";
import { Label } from "../../components/ui/label";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import {
  respEnum,
  IntMax,
  IntMinLevel,
  ClubDisplayTypeEnum,
  MatchTypeEnum,
  DateminFormat,
} from "../../constants/appConstant";
import GoogleMapCustom from "../../components/ui/CustomMap";
import { formatTime } from "../../helper/utilityHelper";
import { useQueryParams } from "../../contexts/queryParamsContext";
import toast from "react-hot-toast";

const formValidations = yup.object({
  name: yup.string().required("Club Name is required"),
  websiteUrl: yup
    .string()
    .url("Enter a valid URL")
    .required("Website URL is required"),
  phone: yup.string().required("Phone number is required"),
  countryId: yup.number().required("Country is required"),
  stateId: yup.number().required("State is required"),
  cityId: yup.number().required("City is required"),
  address: yup.string().required("Address is required"),
  postalCode: yup.number().required("Postal Code is required"),
  lat: yup
    .number()
    .typeError("Latitude must be a number")
    .required("Latitude is required"),
  lng: yup
    .number()
    .typeError("Longitude must be a number")
    .required("Longitude is required"),
  averageRating: yup
    .number()
    .required("Average Rating is required")
    .min(0)
    .max(5),
  cancellationHours: yup.number().required("Cancellation policy is required"),
  startFrom: yup
    .number()
    .required("Start From is required")
    .min(IntMinLevel)
    .max(IntMax),
  userFirstName: yup
    .string()
    .nullable()
    .notRequired()
    .min(2, "User First Name Must be atleast 2 characters")
    .max(50, "User First Name cannot Exceed to more than 50 characters"),
  userLastName: yup
    .string()
    .nullable()
    .notRequired()
    .min(2, "User Last Name Must be atleast 2 characters")
    .max(50, "User Last Name cannot Exceed to more than 50 characters"),
  userEmail: yup
    .string()
    .nullable()
    .notRequired()
    .email("Invalid email format")
    .min(5, "User Email Must be atleast 5 characters")
    .max(50, "User Email cannot Exceed to more than 50 characters"),
  userPassword: yup
    .string()
    .nullable()
    .notRequired()
    .min(2, "User Password Must be atleast 2 characters")
    .max(30, "User Password cannot Exceed to more than 30 characters"),
});

const formInitialValues = {};

const AdvanceformInitialValues = {
  isEmailSentOnBooking: false,
};

export default function ClubSetups() {
  const navigate = useNavigate();
  const location = useLocation();

  const formikRef = useRef();
  // const [position, setPosition] = useState({ lat: 31.4670196, lng: 74.3765426 });
  const [position, setPosition] = useState({ lat: null, lng: null });
  const [isLoading, setIsLoading] = useState(true);
  const [State, setState] = useState([]);
  const [Country, setCountry] = useState([]);
  const [City, setCity] = useState([]);
  var [facilities, setFacilities] = useState([]);
  const [clubImages, setClubImages] = useState([]);
  const [allFacilities, setAllFacilities] = useState([]);
  const [pinLocationName, setpinLocationName] = useState("");
  const [showEmailFields, setShowEmailFields] = useState(false);
  const [showMerchantFields, setShowMerchantFields] = useState(false);
  const [ownersEmails, setOwnersEmails] = useState([""]);
  const [id, setId] = useState(null);
  const [dataLoad, setDataLoad] = useState([]);
  const [activeTab, setActiveTab] = useState("basic");

  const [initialValues, setInitialValues] = useState({
    ownersEmails: [""],
  });

  const { params, setParams } = useQueryParams();

  const [timings, setTimings] = useState(
    Common.Utility.enumToArray(DayOfWeekEnum).map((day) => ({
      ...day,
      isOn: false,
      dayOfweek: day.id,
      openingTime: "",
      closingTime: "",
    }))
  );

  const [formData, setFormData] = useState({});
  const [is24HourChecked, setIs24HourChecked] = useState(false);
  const [thumbnail, setThumbnail] = useState(null);
  const [logo, setLogo] = useState(null);
  const [locationImage, setLocationImage] = useState(null);

  useEffect(() => {
    const fetchedId = params.clubId;

    const fetchInitialData = async () => {
      const allFacility = await GetFacilities();
      setAllFacilities(allFacility);
      await Common.delay();
      getCountries();

      if (fetchedId) {
        setId(fetchedId);
        const clubDetails = await GetClubDetails(allFacility, fetchedId);
        setFormData(clubDetails); // Init data storing
      } else {
        setIsLoading(false);
      }
    };
    fetchInitialData();

    return () => {
      setParams({
        ...params,
        clubId: null,
      });
    };
  }, []);

  const GetFacilities = async () => {
    const response = await Common.ApiService.getInstance().request(
      "GetMasterFacilities"
    );
    const data =
      response?.data?.map((facility) => ({
        ...facility,
        isSelected: false,
      })) ?? [];
    setFacilities(data);
    return data;
  };
  const handelWhatsappBit = (value) => {
    setShowMerchantFields(value === true);
  };

  const GetClubDetails = async (allFacility, id) => {
    setIsLoading(true);
    try {
      let response = await Common.ApiService.getInstance().request(
        `GetMyClubDetails?clubId=${id}`
      );
      const d = response?.data?.[0];

      debugger;
      let formattedFacilities = [];
      if (d && d.facilities.length > 0) {
        //formattedFacilities = allFacility.map((facility) => ({
        //    ...facility,
        //    isSelected: d.facilities.some((cf) => cf.masterFacilityId == facility.id)
        //}));

        formattedFacilities = allFacility.map((facility) => {
          const matchingFacility = d.facilities?.find(
            (cf) => String(cf.masterFacilityId) === String(facility.id)
          );
          return {
            ...facility,
            isSelected: !!matchingFacility,
            masterFacilityId: facility.id,
            masterFacilityName: facility.name,
            icon: facility.icon,
          };
        });
      }

      handelWhatsappBit(d.isownwhatsapp);

      const formattedTimings = Common.Utility.enumToArray(DayOfWeekEnum).map(
        (day) => {
          const timing = d.timings?.find((t) => t.dayOfweek === day.id);
          return {
            ...day,
            isOn: timing ? timing.isOn : false,
            dayOfweek: day.id,
            openingTime:
              timing && timing.isOn ? timing.openingTime.substring(0, 5) : "",
            closingTime:
              timing && timing.isOn ? timing.closingTime.substring(0, 5) : "",
            id: day.id,
          };
        }
      );

      const is24Hour = d.timings?.every(
        (timing) =>
          timing.openingTime === "00:00:00" && timing.closingTime === "23:59:00"
      );
      setIs24HourChecked(is24Hour);

      if (d.countryId) getStates(d.countryId);
      if (d.stateId) getCities(d.stateId);

      debugger;
      if (d.maxBookingHours) d.maxBookingHours = d.maxBookingHours / 24;

      if (d.bookingStartFrom)
        d.bookingStartFrom = moment(d.bookingStartFrom).format(DateminFormat);

      if (d.bookingTill)
        d.bookingTill = moment(d.bookingTill).format(DateminFormat);

      const formattedData = {
        ...d,
        facilities: formattedFacilities,
        timings: formattedTimings,
        countryId: d.countryId || null,
        stateId: d.stateId || null,
        cityId: d.cityId || null,
        images: d.images ?? [],
        ownersEmails: d.ownersEmails
          ? d.ownersEmails
              .replace(/[\[\]"]+/g, "")
              .split(",")
              .map((email) => email.trim())
          : [""],
        isEmailSentOnBooking: Boolean(d.isEmailSentOnBooking),
        files: [],

        thumbnail: d.thumbnail || null,
        logo: d.logo || null,
        locationImage:d.locationImage || null,
      };

      setpinLocationName(formattedData.pinLocationName);
      setFacilities(formattedFacilities);
      setThumbnail(formattedData.thumbnail);
      setLogo(formattedData.logo);
      setLocationImage(formattedData.locationImage);

      const formattedImages = formattedData.images.map((img) => ({
        path: img.path,
        imageUrl: `${Common.AppConstant.imgBaseurl}${img.path}`,
      }));
      setClubImages(formattedImages);

      setTimings(formattedTimings);
      setPosition({
        lat: parseFloat(d.lat) || null,
        lng: parseFloat(d.lng) || null,
      });

      if (d.isEmailSentOnBooking) {
        setShowEmailFields(true);
        const cleanedEmails = d.ownersEmails
          .replace(/[\[\]"]+/g, "")
          .split(",")
          .map((email) => email.trim());

        setOwnersEmails(cleanedEmails);
        setInitialValues((prev) => ({
          ...prev,
          ownersEmails: cleanedEmails,
          isEmailSentOnBooking: true,
        }));
      }

      setDataLoad(d);
      setIsLoading(false);
      return formattedData;
    } catch (error) {
      console.log("y chal raha h");

      console.error("Error fetching club details:", error);
      setIsLoading(false);
      return null;
    }
  };

  const getCountries = async () => {
    return new Promise(async (res) => {
      const response = await Common.ApiService.getInstance().request(
        "GetCountries"
      );
      const data = [
        { id: null, name: "Select Country" },
        ...(response?.data ?? []),
      ];

      setCountry(data);
    });
  };

  const getStates = async (countryId) => {
    try {
      const response = await Common.ApiService.getInstance().request(
        `GetStates?countryId=${countryId}`
      );
      const data = [
        { id: null, name: "Select State" },
        ...(response?.data ?? []),
      ];
      setState(data);
      return data;
    } catch (error) {
      console.error("Error fetching states:", error);
      setState([{ id: null, name: "Select State" }]);
      return [];
    }
  };

  const getCities = async (stateId) => {
    try {
      const response = await Common.ApiService.getInstance().request(
        `GetCities?stateId=${stateId}`
      );
      const data = [
        { id: null, name: "Select City" },
        ...(response?.data ?? []),
      ];
      setCity(data);
      return data;
    } catch (error) {
      console.error("Error fetching cities:", error);
      setCity([{ id: null, name: "Select City" }]);
      return [];
    }
  };

  const _onSubmit = async (d, action) => {

    try {
      // If adding a new club, validate all user fields are provided
      if (!id) {
        if (!d.userFirstName) {
          Common.showToast("User First Name is Required", "Error");
          return;
        }
        if (!d.userLastName) {
          Common.showToast("User Last Name is Required", "Error");
          return;
        }
        if (!d.userEmail) {
          Common.showToast("User Email is Required", "Error");
          return;
        }
        if (!d.userPassword) {
          Common.showToast("User Password is Required", "Error");
          return;
        }
      }

      // Continue with the rest of validation and submission
      await formValidations.validate(d, { abortEarly: false });

      // Rest of your existing submission code
      let data = {
        ...d,
        lat: d.lat ? String(d.lat) : "",
        lng: d.lng ? String(d.lng) : "",
        minimumBookingHours: d.minimumBookingHours
          ? +d.minimumBookingHours
          : null,
        maxBookingHours: d.maxBookingHours ? +d.maxBookingHours * 24 : null,
        startFrom: +d.startFrom,
        displayType: d.displayType ? d.displayType : null,
        privacytype: d.privacytype ? d.privacytype : null,
        skipMidTime: d.skipMidTime ? d.skipMidTime : false,
        bookingStartFrom: d.bookingStartFrom ? d.bookingStartFrom : null,
        bookingTill: d.bookingTill ? d.bookingTill : null,
        defaultMatchType: d.defaultMatchType ? d.defaultMatchType : null,
        merchant_invoice_password: showMerchantFields
          ? d.merchant_invoice_password
          : null,
        merchant_invoice_username: showMerchantFields
          ? d.merchant_invoice_username
          : null,
      };
    
      if (!data.facilities.length) {
        Common.showToast("Add at least one facility", "Error");
        return;
      }
      data.facilities = d.facilities.filter(facility=>facility.isSelected).map((facility) => ({
        // masterFacilityId: facility.masterFacilityId
        //   ? facility.masterFacilityId
        //   : facility.id,
        // masterFacilityName: facility.masterFacilityName
        //   ? facility.masterFacilityName
        //   : facility.name,

        masterFacilityId:facility.id,
        masterFacilityName:facility.name,
      }));

      if (d.thumbnail instanceof File) {
        var thumbnail = (
          await Common.Utility.handleFileUpload([d.thumbnail])
        )[0].photo;
        d.thumbnail = thumbnail;
        data.thumbnail = thumbnail;
      }

      if (d.logo instanceof File) {
        var logo = (
          await Common.Utility.handleFileUpload(
            [d.logo],
            ImageFolderEnum.trmt_logo
          )
        )[0].photo;
        d.logo = logo;
        data.logo = logo;
      }

         if (d.locationImage instanceof File) {
        var locationImage = (
          await Common.Utility.handleFileUpload(
            [d.locationImage],
            ImageFolderEnum.upload
          )
        )[0].photo;
        d.locationImage = locationImage;
        data.locationImage = locationImage;
      }

      let uploadedFiles = [];
      if (d.clubImages?.some((item) => item instanceof File)) {
        var filesToBeUploaded = d.clubImages.filter(
          (item) => item instanceof File
        );

        let _files = await Common.Utility.handleFileUpload(filesToBeUploaded);
        uploadedFiles = [
          ...clubImages,
          ..._files.map((item) => ({
            id: 0,
            path: item.photo,
          })),
        ];
      } else {
        uploadedFiles = [...clubImages];
      }
      data.images = uploadedFiles;

      if (!data.images.length) {
        Common.showToast("Add at least one Image", "Error");
        return;
      }

      // merchant invoice validation

      if (
        d.isownwhatsapp &&
        (!d.merchant_invoice_username || !d.merchant_invoice_password)
      ) {
        toast.error("Please Fill Merchant Inovoice Details");
        return;
      }

      // Email validation
      var Emails = d.ownersEmails
        ? d.ownersEmails.filter((email) => email.trim() !== "")
        : [];

      // Check for commas in emails
      const invalidEmail = Emails.find((email) => email.includes(","));
      if (invalidEmail) {
        Common.showToast(
          "Invalid email format: Comma is not allowed.",
          "Error"
        );
        return;
      }

      // Email format validation - check each email
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      const invalidFormatEmail = Emails.find(
        (email) => !emailRegex.test(email.trim())
      );

      if (invalidFormatEmail) {
        Common.showToast(
          `Invalid email format: "${invalidFormatEmail}" is not a valid email address.`,
          "Error"
        );
        return;
      }

      if (data.isEmailSentOnBooking && Emails.length === 0) {
        Common.showToast("At least one valid email is required.", "Error");
        return;
      }

      data.ownersEmails = Emails.length > 0 ? JSON.stringify(Emails) : "[]";

      if (data.timings?.length) {
        let invalidTime = data.timings.find((item) => {
          if (!item.isOn) return false;

          const isOpeningTimeValid = Common.Utility.CheckTime(item.openingTime);
          const isClosingTimeValid = Common.Utility.CheckTime(item.closingTime);
          const validTime = item.openingTime < item.closingTime;

          if (
            !item.openingTime ||
            !item.closingTime ||
            !isOpeningTimeValid ||
            !isClosingTimeValid ||
            !validTime
          ) {
            const dayName = Common.Utility.getKeyByValue(
              DayOfWeekEnum,
              item.dayOfweek
            );

            if (!item.openingTime) {
              Common.showToast(`Provide opening time for ${dayName}`, "Error");
              return true;
            }

            if (!isOpeningTimeValid) {
              Common.showToast(
                `Invalid time format for opening time. Expected formats: 00, 30, or 23:59 for ${dayName}`,
                "Error"
              );
              return true;
            }

            if (!item.closingTime) {
              Common.showToast(`Provide closing time for ${dayName}`, "Error");
              return true;
            }

            if (!isClosingTimeValid) {
              Common.showToast(
                `Invalid time format for closing time. Expected formats: 00, 30, or 23:59 for ${dayName}`,
                "Error"
              );
              return true;
            }

            if (!validTime) {
              Common.showToast(
                `Closing time must be greater than opening time for ${dayName}`,
                "Error"
              );
              return true;
            }
          }
          return false;
        });

        if (invalidTime) return;
      }
      debugger
      data.timings = data.timings.map((item) => ({
        ...item,
        openingTime: item.isOn
          ? Common.Utility.formatTimeToCSharp(item.openingTime)
          : null,
        closingTime: item.isOn
          ? Common.Utility.formatTimeToCSharp(item.closingTime)
          : null,
      }));
      let response = await Common.ApiService.getInstance().request(
        "AddUpdateClub",
        data,
        "POST"
      );

      action.setSubmitting(false);
      if (response.status == respEnum.Success) {
        Common.SweetAlert.alert(response.message);
        setTimeout(() => {
          navigate("/app/clubs");
        }, 500);
      }
    } catch (error) {
      action.setSubmitting(false);

      // If it's a validation error
      if (error.name === "ValidationError") {
        // Show first error in toast
        Common.showToast(error.errors[0], "Error");

        // Determine which tab the error field belongs to
        const fieldName = error.inner[0]?.path;
        if (fieldName) {
          // Map field names to their corresponding tabs
          const fieldToTabMap = {
            // Basic tab fields
            name: "basic",
            websiteUrl: "basic",
            phone: "basic",
            countryId: "basic",
            stateId: "basic",
            cityId: "basic",
            address: "basic",
            postalCode: "basic",
            lat: "basic",
            lng: "basic",
            averageRating: "basic",

            // Advance tab fields
            startFrom: "advance",
            cancellationHours: "advance",
            facilities: "advance",

            // Timings tab fields
            timings: "timings",
            // Add other fields as needed
          };

          // Get the tab that contains the error field
          const tabWithError = fieldToTabMap[fieldName] || activeTab;

          // Switch to that tab
          if (tabWithError !== activeTab) {
            handleTabChange(tabWithError);
          }

          // Focus the field with error (add a short delay to ensure tab change completes)
          setTimeout(() => {
            const element = document.getElementsByName(fieldName)[0];
            if (element) {
              element.scrollIntoView({ behavior: "smooth", block: "center" });
              element.focus();
            }
          }, 300);
        }
      } else {
        // Handle other errors
        Common.showToast(error.message || "An error occurred", "Error");
      }
    }
  };

  const handleRemoveClubImage = (indexToRemove) => {
    const updatedImages = clubImages.filter(
      (_, index) => index !== indexToRemove
    );
    setClubImages(updatedImages);
  };

  const handleLocationChange = (newPosition) => {
    setPosition(newPosition);
    if (formikRef.current) {
      formikRef.current.setFieldValue("lat", Number(newPosition.lat));
      formikRef.current.setFieldValue("lng", Number(newPosition.lng));
      formikRef.current.setFieldValue(
        "pinLocationName",
        newPosition.pinLocationName
      );
      setpinLocationName(newPosition.pinLocationName);
    }
  };

  const Heading = ({ text }) => (
    <h4 class="text-2xl font-bold dark:text-white mb-5">{text}</h4>
  );

  const handleTabChange = async (tab) => {
    if (formikRef.current) {
      const currentValues = formikRef.current.values;

      setFormData((prev) => {
        const newData = { ...prev, ...currentValues };

        let updatedFacilities = [];
        if (currentValues && currentValues.facilities) {
          updatedFacilities = allFacilities.map((facility) => {
            const matchingFacility = currentValues.facilities?.find(
              (cf) => String(cf.id) === String(facility.id)
            );
            return {
              ...facility,
              isSelected: matchingFacility
                ? matchingFacility.isSelected
                : false,
              masterFacilityId: facility.id,
              masterFacilityName: facility.name,
              icon: facility.icon,
            };
          });
          setFacilities(updatedFacilities);
        }

        // Handle timings with proper time format
        if (currentValues.timings) {
          const updatedTimings = currentValues.timings.map((timing) => ({
            ...timing,
            openingTime: timing.isOn ? timing.openingTime || "00:00" : "",
            closingTime: timing.isOn ? timing.closingTime || "23:59" : "",
          }));
          setTimings(updatedTimings);
        }

        return newData;
      });
    }
    setActiveTab(tab);
  };

  const formatServerTime = (time) => {
    if (!time) return "";
    return time.substring(0, 5);
  };

  // Add form change handlers
  const handleCountryChange = async (value, formikProps) => {
    if (value) {
      const states = await getStates(value);
      formikProps.setFieldValue("countryId", value);
      formikProps.setFieldValue("stateId", null);
      formikProps.setFieldValue("cityId", null);
      setCity([{ id: null, name: "Select City" }]);
    } else {
      formikProps.setFieldValue("countryId", null);
      formikProps.setFieldValue("stateId", null);
      formikProps.setFieldValue("cityId", null);
      setState([{ id: null, name: "Select State" }]);
      setCity([{ id: null, name: "Select City" }]);
    }
  };

  const handleStateChange = async (value, formikProps) => {
    if (value) {
      const cities = await getCities(value);
      formikProps.setFieldValue("stateId", value);
      formikProps.setFieldValue("cityId", null);
    } else {
      formikProps.setFieldValue("stateId", null);
      formikProps.setFieldValue("cityId", null);
      setCity([{ id: null, name: "Select City" }]);
    }
  };

  const handleFacilityChange = (facilities, formikProps) => {
    const updatedFacilities = allFacilities.map((masterFacility) => ({
      ...masterFacility,
      isSelected: facilities.some(
        (f) => f.masterFacilityId === masterFacility.id
      ),
      masterFacilityId: masterFacility.id,
      masterFacilityName: masterFacility.name,
    }));

    setFacilities(updatedFacilities);
    formikProps.setFieldValue("facilities", updatedFacilities);
  };

  const handleImageChange = (files, formikProps) => {
    const updatedImages = files.map((file) => {
      if (file.imageUrl) {
        return { path: file.imageUrl };
      }

      const blobUrl = URL.createObjectURL(file);
      const blobId = blobUrl.split("/").pop();
      return { path: blobId };
    });
    setClubImages(updatedImages);
    formikProps.setFieldValue("files", files);
  };

  const handleEmailChange = (isEnabled, formikProps) => {
    setShowEmailFields(isEnabled);
    formikProps.setFieldValue("isEmailSentOnBooking", isEnabled);
    if (!isEnabled) {
      setOwnersEmails([""]);
      formikProps.setFieldValue("ownersEmails", [""]);
    }
  };

  const handle24HourToggle = (formikProps) => {
    const newIs24HourChecked = !is24HourChecked;
    setIs24HourChecked(newIs24HourChecked);

    const updatedTimings = timings.map((timing) => ({
      ...timing,
      isOn: newIs24HourChecked,
      openingTime: newIs24HourChecked ? "00:00" : "",
      closingTime: newIs24HourChecked ? "23:59" : "",
    }));

    setTimings(updatedTimings);
    formikProps.setFieldValue("timings", updatedTimings);
  };

  const handleThumbnailChange = (file, formikProps) => {
    debugger;
    setThumbnail(file);
    formikProps.setFieldValue("thumbnail", file);
  };

  const handleLogoChange = (file, formikProps) => {
    setLogo(file);
    formikProps.setFieldValue("logo", file);
  };

  const handleLocationImageChange = (file, formikProps) => {
    setLocationImage(file);
    formikProps.setFieldValue("locationImage", file);
  };
  return (
    <Formik
      initialValues={formData}
      validationSchema={formValidations}
      innerRef={formikRef}
      validateOnChange={false}
      validateOnBlur={false}
      onSubmit={_onSubmit}
      enableReinitialize={true}
      validateOnMount={false}
    >
      {(formikProps) => (
        <Card>
          <CardContent className="p-3">
            <Tabs defaultValue="basic" className="w-full">
              <TabsList className="border bg-background">
                <TabsTrigger
                  value="basic"
                  className="data-[state=active]:bg-primary data-[state=active]:text-primary-foreground"
                  onClick={() => handleTabChange("basic")}
                >
                  <Icon icon="lucide:sliders" className="h-5 w-5 mr-2" />
                  Basic
                </TabsTrigger>
                <TabsTrigger
                  value="advance"
                  className="data-[state=active]:bg-primary data-[state=active]:text-primary-foreground"
                  onClick={() => handleTabChange("advance")}
                >
                  <Icon icon="lucide:layers" className="h-5 w-5 mr-2" />
                  Advance
                </TabsTrigger>
                <TabsTrigger
                  value="timings"
                  className="data-[state=active]:bg-primary data-[state=active]:text-primary-foreground"
                  onClick={() => handleTabChange("timings")}
                >
                  <Icon icon="lucide:calendar-clock" className="h-5 w-5 mr-2" />
                  Timings
                </TabsTrigger>
              </TabsList>

              {activeTab === "basic" && (
                <>
                  <div className="md:grid md:grid-cols-7 mb-10 gap-2 space-y-3 md:space-y-0">
                    <div className="col-span-3">
                      <Heading text={"Info"} />
                      <div className="md:grid md:grid-cols-2 gap-4">
                        {/* First Row */}
                        <div className="flex flex-col gap-2">
                          <FormikInput
                            formikProps={formikProps}
                            name={"name"}
                            placeholder={"Enter Club Name"}
                            label={"Club Name"}
                          />
                        </div>
                        <div className="flex flex-col gap-2">
                          <FormikInput
                            formikProps={formikProps}
                            name={"websiteUrl"}
                            placeholder={"Enter Website Url"}
                            label={"Website Url"}
                          />
                        </div>

                        {/* Second Row */}
                        <div className="flex flex-col gap-2">
                          <FormikInput
                            formikProps={formikProps}
                            name={"phone"}
                            placeholder={"Enter Phone Number"}
                            label={"Phone Number"}
                          />
                        </div>

                        <div className="flex flex-col gap-2">
                          <StarRating
                            formikProps={formikProps}
                            name={"averageRating"}
                            label={"Average Rating"}
                          />
                        </div>
                      </div>

                      <div className="col-span-3 mt-5">
                        <div className="md:grid md:grid-cols-1  gap-2  space-y-3 md:space-y-0">
                          <div className="flex flex-col gap-2">
                            <FormikTextArea
                              formikProps={formikProps}
                              name={"desc"}
                              placeholder={"Enter description"}
                              label={"Description"}
                              maxLength={500}
                              rows={5}
                            />
                          </div>
                        </div>
                      </div>
                      {/* Divider */}
                      <div className="col-span-7">
                        <div
                          style={{
                            height: 1,
                            backgroundColor: "#D3D3D3",
                            marginTop: 20,
                            marginBottom: 20,
                          }}
                        />
                      </div>

                      <div className="col-span-4">
                        <Heading text={"Status & Visibility"} />
                        <div className="md:grid md:grid-cols-4 gap-4 space-y-3 md:space-y-0">
                          <div className="flex flex-col gap-2">
                            <FormikSwitch
                              formikProps={formikProps}
                              name={"isCommingSoon"}
                              label={"Coming Soon"}
                              className="mt-2 ml-3"
                            />
                          </div>

                          <div className="flex flex-col gap-2">
                            <FormikSwitch
                              formikProps={formikProps}
                              name={"isDisplayonApp"}
                              label={"Display on App"}
                              className="mt-2 ml-3"
                            />
                          </div>

                          <div className="flex flex-col gap-2">
                            <FormikSwitch
                              formikProps={formikProps}
                              name={"isapproved"}
                              label={"Approve"}
                              className="mt-2 ml-3"
                            />
                          </div>

                          <div className="flex flex-col gap-2">
                            <FormikSwitch
                              formikProps={formikProps}
                              name={"isactive"}
                              label={"Active"}
                              className="mt-2 ml-3"
                            />
                          </div>

                          {/*<div className="flex flex-col gap-2">*/}
                          {/*  <FormikSwitch*/}
                          {/*    formikProps={formikProps}*/}
                          {/*    name={"isdeleted"}*/}
                          {/*    label={"Deleted"}*/}
                          {/*    className="mt-2 ml-3"*/}
                          {/*  />*/}
                          {/*</div>*/}
                        </div>
                      </div>

                      <div className="col-span-7">
                        <div
                          style={{
                            height: 1,
                            backgroundColor: "#D3D3D3",
                            marginTop: 20,
                            marginBottom: 20,
                          }}
                        />
                      </div>

                      <div className="col-span-3">
                        <Heading text={"Thumbnail"} />
                        <div className="md:grid md:grid-cols-1  gap-2 space-y-3 md:space-y-0">
                          <div className="flex flex-col gap-2">
                            <FormikSingleWithMultiUploadInAPage
                              formikProps={formikProps}
                              uploadMainTxt="Upload Thumbnail"
                              uploadTxt="Max size 2mb"
                              name="thumbnail"
                              maxFileUploadSize={2}
                              value={thumbnail}
                              onChange={(file) =>
                                handleThumbnailChange(file, formikProps)
                              }
                            />
                          </div>
                        </div>
                      </div>

                      <br></br>
                      <Heading text={"Logo"} />
                      <div className="md:grid md:grid-cols-1  gap-2 space-y-3 md:space-y-0">
                        <div className="flex flex-col gap-2">
                          <FormikSingleWithMultiUploadInAPage
                            formikProps={formikProps}
                            uploadMainTxt="Upload Logo"
                            uploadTxt="Max size 2mb"
                            name="logo"
                            maxFileUploadSize={1}
                            value={logo}
                            onChange={(file) =>
                              handleLogoChange(file, formikProps)
                            }
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-span-1 h-full flex justify-center">
                      <span className="border-r-2" />
                    </div>

                    <div className="col-span-3">
                      {!id && (
                        <div>
                          <div className="col-span-4">
                            <Heading text={"User Info"} />
                            <div className="md:grid md:grid-cols-2 gap-4 space-y-3 md:space-y-0">
                              <div className="flex flex-col gap-2">
                                <FormikInput
                                  formikProps={formikProps}
                                  name={"userFirstName"}
                                  placeholder={"Enter First Name"}
                                  label={"User First Name"}
                                  maxLength={50}
                                  autoComplete="new-Fname"
                                />
                              </div>

                              <div className="flex flex-col gap-2">
                                <FormikInput
                                  formikProps={formikProps}
                                  name={"userLastName"}
                                  placeholder={"Enter Last Name"}
                                  label={"User Last Name"}
                                  maxLength={50}
                                  autoComplete="new-Lname"
                                />
                              </div>

                              <div className="flex flex-col gap-2">
                                <FormikInput
                                  formikProps={formikProps}
                                  name={"userEmail"}
                                  placeholder={"Enter User Email"}
                                  label={"User Email"}
                                  maxLength={50}
                                  autoComplete="new-email"
                                />
                              </div>

                              <div className="flex flex-col gap-2">
                                <FormikInput
                                  formikProps={formikProps}
                                  type="password"
                                  name={"userPassword"}
                                  placeholder={"Enter User Password"}
                                  label={"User Password"}
                                  maxLength={30}
                                  autoComplete="new-password"
                                />
                              </div>
                            </div>
                          </div>

                          <div className="col-span-7">
                            <div
                              style={{
                                height: 1,
                                backgroundColor: "#D3D3D3",
                                marginTop: 20,
                                marginBottom: 20,
                              }}
                            />
                          </div>
                        </div>
                      )}
                      <Heading text={"Location"} />
                      <div className="md:grid md:grid-cols-1  gap-2  space-y-3 md:space-y-0">
                        <div className="md:grid md:grid-cols-2  gap-2 gap-4   space-y-3 md:space-y-0">
                          <FormikSearchSelect
                            formikProps={formikProps}
                            name={"countryId"}
                            placeholder={"Select Country"}
                            label={"Country"}
                            data={Country}
                            onChange={(val) =>
                              handleCountryChange(val, formikProps)
                            }
                          />
                          <FormikInput
                            formikProps={formikProps}
                            name={"postalCode"}
                            placeholder={"Enter Postal Code"}
                            label={"Postal Code"}
                            type={"number"}
                          />
                        </div>

                        <div className="md:grid">
                          <div className="md:grid md:grid-cols-2  gap-4 space-y-3 md:space-y-0">
                            <FormikSearchSelect
                              formikProps={formikProps}
                              name={"stateId"}
                              placeholder={"Select State"}
                              label={"State"}
                              data={State}
                              onChange={(val) =>
                                handleStateChange(val, formikProps)
                              }
                            />

                            <FormikSearchSelect
                              formikProps={formikProps}
                              name={"cityId"}
                              placeholder={"Select City"}
                              label={"City"}
                              data={City}
                            />
                          </div>
                        </div>

                        <div className="flex flex-col gap-2">
                          <FormikInput
                            formikProps={formikProps}
                            name={"area"}
                            placeholder={"Enter Area"}
                            label={"Area (Optional)"}
                          />
                        </div>

                        <div className="flex flex-col gap-2">
                          <FormikTextArea
                            formikProps={formikProps}
                            name={"address"}
                            placeholder={"Enter Address"}
                            label={"Address"}
                          />
                        </div>

                        <div>
                          <h3 className="text-xl font-bold mb-4">
                            Pick a Location
                          </h3>
                          {!isLoading && (
                            <GoogleMapCustom
                              defaultLat={position.lat}
                              defaultLng={position.lng}
                              pinLocationName={pinLocationName}
                              onLocationChange={handleLocationChange}
                            />
                          )}
                        </div>


                      <Heading text={"Location Image"} />
                      <div className="md:grid md:grid-cols-1  gap-2 space-y-3 md:space-y-0">
                        <div className="flex flex-col gap-2">
                          <FormikSingleWithMultiUploadInAPage
                            formikProps={formikProps}
                            uploadMainTxt="Upload Location Image"
                            uploadTxt="Max size 2mb"
                            name="locationImage"
                            maxFileUploadSize={1}
                            value={locationImage}
                            onChange={(file) =>
                              handleLocationImageChange(file, formikProps)
                            }
                          />
                        </div>
                      </div>

                        <div className="md:grid ">
                          <div
                            className="md:grid md:grid-cols-2 gap-6 space-y-3 md:space-y-0 .hidden-important"
                            style={{ display: "none" }}
                            ref={(el) => {
                              if (el)
                                el.style.setProperty(
                                  "display",
                                  "none",
                                  "important"
                                );
                            }}
                          >
                            <div className="flex flex-col gap-3">
                              <FormikInput
                                formikProps={formikProps}
                                name={"lat"}
                                placeholder={"Enter Latitude"}
                                label={"Latitude"}
                                type={"number"}
                                disabled={true}
                              />
                            </div>

                            <div className="flex flex-col gap-3">
                              <FormikInput
                                formikProps={formikProps}
                                name={"lng"}
                                placeholder={"Enter Longitude"}
                                label={"Longitude"}
                                type={"number"}
                                disabled={true}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}

              {activeTab === "advance" && (
                <>
                  <div className="md:grid md:grid-cols-7 mb-10 gap-2 space-y-3 md:space-y-0">
                    {/* Row 1 Starts Here */}
                    <div className="col-span-3">
                      <Heading text={"Facilities"} />
                      <div className="md:grid md:grid-cols-1 gap-2 space-y-3 md:space-y-0">
                        <FacilitiesCard
                          formikProps={formikProps}
                          data={facilities}
                          name={"facilities"}
                          title={"Facilities"}
                          onChange={(facilities) =>
                            handleFacilityChange(facilities, formikProps)
                          }
                        />
                      </div>
                    </div>
                    <div className="col-span-1 h-full flex justify-center">
                      <span className="border-r-2" />
                    </div>
                    <div className="col-span-3">
                      <Heading text={"Bookings"} />
                      {/* Adjusted grid layout */}
                      <div className="md:grid md:grid-cols-3 gap-4 space-y-3 md:space-y-0">
                        {/* Existing Fields */}
                        <div className="flex flex-col gap-2">
                          <FormikDate
                            formikProps={formikProps}
                            name={"bookingStartFrom"}
                            type={"date"}
                            placeholder={"Booking Start From"}
                            label={"Booking Start From"}
                            // min={Common.Utility.today}
                            // onChange={(val) => {
                            //     Common.Utility.checkPreviousDate(val, "bookingStartFrom");
                            //  }}
                          />
                        </div>

                        <div className="flex flex-col gap-2">
                          <FormikDate
                            formikProps={formikProps}
                            name={"bookingTill"}
                            type={"date"}
                            placeholder={"Booking Till"}
                            label={"Booking Till"}
                            // min={Common.Utility.today}
                          />
                        </div>

                        <div className="flex flex-col gap-2">
                          <FormikInput
                            formikProps={formikProps}
                            name={"startFrom"}
                            placeholder={"Start From"}
                            label={"Start From"}
                            min={IntMinLevel}
                            max={IntMax}
                            onChange={(value) => {
                              if (value < IntMinLevel && value != "") {
                                formikProps.setFieldValue("startFrom", "");
                              } else if (value > IntMax) {
                                Common.showToast(
                                  `Start From cannot be greater than ${IntMax}`
                                );
                                formikProps.setFieldValue("startFrom", "");
                              } else {
                                formikProps.setFieldValue("startFrom", value);
                              }
                            }}
                          />
                        </div>

                        <div className="flex flex-col gap-2">
                          <FormikInput
                            formikProps={formikProps}
                            name={"cancellationHours"}
                            placeholder={"Cancellation policy (hours)"}
                            label={"Cancellation Policy (hours)"}
                          />
                        </div>
                        <div className="flex flex-col gap-2">
                          <FormikInput
                            formikProps={formikProps}
                            name={"minimumBookingHours"}
                            placeholder={"Min booking hours"}
                            label={"Minimum Hours Before Booking"}
                            type={"number"}
                          />
                        </div>
                        <div className="flex flex-col gap-2">
                          <FormikInput
                            formikProps={formikProps}
                            name={"maxBookingHours"}
                            type={"number"}
                            placeholder={"Max booking/day"}
                            label={"Maximum Advance Days for Booking"}
                          />
                        </div>

                        <div className="flex flex-col gap-2">
                          <FormikSelect
                            formikProps={formikProps}
                            name="displayType"
                            data={[
                              { id: null, name: "Select" },
                              ...Common.Utility.enumToArray(
                                ClubDisplayTypeEnum
                              ),
                            ]}
                            placeholder={"Enter Display Type"}
                            label={"Display Type"}
                          />
                        </div>

                        <div className="flex flex-col gap-2">
                          <FormikSelect
                            formikProps={formikProps}
                            name="defaultMatchType"
                            data={[
                              { id: null, name: "Select" },
                              ...Common.Utility.enumToArray(MatchTypeEnum),
                            ]}
                            placeholder={"Default Match Type"}
                            label={"Default Match Type"}
                          />
                        </div>
                        <div className="flex flex-col gap-2">
                          <FormikInput
                            formikProps={formikProps}
                            name={"externaldiscountpercent"}
                            type={"number"}
                            placeholder={"External Discount Percentage"}
                            label={"External Discount %"}
                            min={0}
                            max={100}
                          />
                        </div>
                        <div className="flex flex-col gap-2">
                          <FormikInput
                            formikProps={formikProps}
                            name={"discountPercent"}
                            type={"number"}
                            placeholder={"Discount Percentage"}
                            label={"Discount % (Optional)"}
                            min={0}
                            max={100}
                          />
                        </div>
                         <div className="flex flex-col gap-2">
                          <FormikInput
                            formikProps={formikProps}
                            name={"defaultOtpHeaderName"}
                            type={"text"}
                            placeholder={"Default Header Name"}
                            label={"Default Header Name (Optional)"}
                          />
                        </div>
                        <div className="flex flex-col gap-2">
                          <FormikSwitch
                            formikProps={formikProps}
                            name={"skipMidTime"}
                            label={"Skip Mid Time"}
                            className="mt-2 ml-3"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-span-7">
                      <div
                        style={{
                          height: 1,
                          backgroundColor: "#D3D3D3",
                          marginTop: 20,
                          marginBottom: 20,
                        }}
                      />
                    </div>

                    {/* Row 1 Starts Here */}

                    {/* Row 2 Starts Here */}
                    <div className="col-span-3">
                      <Heading text={"Images"} />
                      <FormikMultiWithSingleUploadInAPage
                        formikProps={formikProps}
                        title="Drop Images here or click to upload"
                        description="PNG, JPG, JPEG files only and maximum size of 1 MB each"
                        maxFileUploadSize={1}
                        renderImagetoState={clubImages}
                        feildName={"clubImages"}
                        // feildName={"files"}
                        renderImage={true}
                      />

                      {clubImages.length > 0 && (
                        <>
                          <h3 className="text-lg font-semibold mt-4 mb-2">
                            Current Images
                          </h3>
                          <Swiper
                            navigation={true}
                            modules={[Navigation]}
                            slidesPerView={
                              clubImages.length === 1
                                ? 1
                                : clubImages.length === 2
                                ? 2
                                : 3
                            }
                            spaceBetween={10}
                            className="mySwiper mt-4"
                          >
                            {clubImages.map((image, index) => (
                              <SwiperSlide key={index} className="relative">
                                <img
                                  // src={`${Common.AppConstant.imgBaseurl}${image.path}`}
                                  src={Common.Utility.getImagePath(image.path)}
                                  alt={`Club ${index + 1}`}
                                  className="w-full h-64 object-cover rounded-md"
                                />
                                <button
                                  className="absolute top-2 right-2 bg-red-500 text-white p-2 rounded-full"
                                  onClick={() => handleRemoveClubImage(index)}
                                >
                                  <Icon icon="tabler:x" className="h-5 w-5" />
                                </button>
                              </SwiperSlide>
                            ))}
                          </Swiper>
                        </>
                      )}
                    </div>
                    <div className="col-span-1 h-full flex justify-center">
                      <span className="border-r-2" />
                    </div>

                    <div className="col-span-3 w-full">
                      <Heading text={"Email"} />
                      <div className="flex flex-col items-center w-full">
                        <div className="flex w-full mb-4">
                          <FormikSwitch
                            formikProps={formikProps}
                            name={"isEmailSentOnBooking"}
                            label={"Email Sent On Booking"}
                            className="mt-2"
                            onChange={(value) =>
                              handleEmailChange(value, formikProps)
                            }
                          />
                        </div>

                        {showEmailFields && (
                          <div className="max-w-2xl p-6 border rounded-lg bg-gray-100 shadow-md mr-14 max-h-80 overflow-y-auto">
                            <h3 className="font-semibold text-lg mb-3 text-center">
                              Owners Emails
                            </h3>
                            <FieldArray name="ownersEmails">
                              {({ push, remove }) => (
                                <>
                                  {formikProps.values.ownersEmails?.map(
                                    (email, index) => (
                                      <div
                                        key={index}
                                        className="flex items-center gap-2 mb-3 w-full"
                                      >
                                        <FormikInput
                                          formikProps={formikProps}
                                          name={`ownersEmails.${index}`}
                                          placeholder="Enter Email"
                                          className="flex-1 min-w-[100px] md:min-w-[200px] lg:min-w-[300px]"
                                          value={email}
                                        />
                                        <Button
                                          type="button"
                                          className="p-1 bg-green-500 text-white rounded-full w-6 h-6 flex items-center justify-center"
                                          onClick={() => {
                                            setOwnersEmails([
                                              ...ownersEmails,
                                              "",
                                            ]);
                                            push("");
                                          }}
                                        >
                                          <Plus size={20} />
                                        </Button>
                                      </div>
                                    )
                                  )}
                                </>
                              )}
                            </FieldArray>
                          </div>
                        )}
                      </div>

                      <div className="col-span-4">
                        <Heading text={"Other Info"} />
                        <div className="md:grid md:grid-cols-4 gap-4 space-y-3 md:space-y-0">
                          <div className="flex flex-col gap-2">
                            <FormikSwitch
                              formikProps={formikProps}
                              name={"isownapp"}
                              label={"Is OwnApp"}
                              className="mt-2 ml-3"
                            />
                          </div>

                          <div className="flex flex-col gap-2">
                            <FormikSwitch
                              formikProps={formikProps}
                              name={"isownweb"}
                              label={"Is Own Web"}
                              className="mt-2 ml-3"
                            />
                          </div>

                          <div className="flex flex-col gap-2">
                            <FormikSwitch
                              formikProps={formikProps}
                              name={"isexternal"}
                              label={"Is External"}
                              className="mt-2 ml-3"
                            />
                          </div>

                          <div className="flex flex-col gap-2">
                            <FormikSwitch
                              formikProps={formikProps}
                              name={"isfacilitieson"}
                              label={"Is Facilities On"}
                              className="mt-2 ml-3"
                            />
                          </div>
                        </div>
                      </div>
                      <br></br>

                      <div className="md:grid md:grid-cols-3 gap-4 space-y-3 md:space-y-0">
                        {/* Existing Fields */}
                        <div className="flex flex-col gap-2">
                          <FormikSelect
                            formikProps={formikProps}
                            name="privacytype"
                            placeholder={"Enter Privacy Type"}
                            data={[
                              { id: null, name: "Select" },
                              ...Common.Utility.enumToArray(
                                ClubPrivacyTypeEnum
                              ),
                            ]}
                            label={"Privacy Type"}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-span-7">
                      <div
                        style={{
                          height: 1,
                          backgroundColor: "#D3D3D3",
                          marginTop: 20,
                          marginBottom: 20,
                        }}
                      />
                    </div>
                    {/* Row 2 end here */}

                    <div className="col-span-3">
                      <Heading text={"PayFast "} />
                      <div className="md:grid md:grid-cols-2 gap-4">
                        {/* Adjusted grid layout */}
                        <div className="flex flex-col gap-2">
                          <FormikInput
                            formikProps={formikProps}
                            name={"merchantId"}
                            type={"text"}
                            placeholder={"Merchant Id"}
                            label={"Merchant Id"}
                          />
                        </div>
                        <div className="flex flex-col gap-2">
                          <FormikInput
                            formikProps={formikProps}
                            name={"merchantName"}
                            type={"text"}
                            placeholder={"Merchant Name"}
                            label={"Merchant Name"}
                          />
                        </div>
                        <div className="flex flex-col gap-2">
                          <FormikInput
                            formikProps={formikProps}
                            name={"merchantSecuredKey"}
                            type={"text"}
                            placeholder={"Secured Key"}
                            label={"Merchant Secured Key"}
                          />
                        </div>
                        <div className="flex flex-col gap-2">
                          <FormikSwitch
                            formikProps={formikProps}
                            name={"isownwhatsapp"}
                            label={"Is Own Whatsapp"}
                            className="mt-2 ml-3"
                            onChange={(value) => handelWhatsappBit(value)}
                          />
                        </div>

                        {showMerchantFields && (
                          <>
                            <FormikInput
                              formikProps={formikProps}
                              name={"merchant_invoice_username"}
                              type={"text"}
                              label={"Merchant Invoice Username"}
                              placeholder={"Merchant Invoice UserName"}
                            
                            />

                            <FormikInput
                              formikProps={formikProps}
                              name={"merchant_invoice_password"}
                              type={"password"}
                              placeholder={"Merchant Invoice Password"}
                              label={"Merchant Invoice Password"}
                           
                            />
                          </>
                        )}
                      </div>
                    </div>
                    <div className="col-span-1 h-full flex justify-center">
                      <span className="border-r-2" />
                    </div>
                  </div>
                </>
              )}

              {activeTab === "timings" && (
                <>
                  <TimingsCard
                    formikProps={formikProps}
                    name={"timings"}
                    data={timings}
                    showCustomButton={true}
                    emptyState={id ? false : true}
                    onChange={(newTimings) => {
                      const updatedTimings = newTimings.map((timing) => ({
                        ...timing,
                        openingTime: timing.isOn
                          ? timing.openingTime || "00:00"
                          : "",
                        closingTime: timing.isOn
                          ? timing.closingTime || "23:59"
                          : "",
                      }));
                      setTimings(updatedTimings);
                      formikProps.setFieldValue("timings", updatedTimings);
                    }}
                  />
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      marginTop: "1rem",
                    }}
                  ></div>
                </>
              )}

              <div className="col-span-7">
                <div
                  style={{
                    height: 1,
                    backgroundColor: "#D3D3D3",
                    marginTop: 20,
                    marginBottom: 20,
                  }}
                />
              </div>
              {/* Submit Button */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  marginTop: "1rem",
                }}
              >
                <Button
                  className=""
                  type={"submit"}
                  onClick={(e) => {
                    e.preventDefault();
                    formikProps.handleSubmit();
                  }}
                  disabled={formikProps.isSubmitting}
                >
                  {formikProps.isSubmitting ? "Saving..." : "Save"}
                </Button>
              </div>
            </Tabs>
          </CardContent>
        </Card>
      )}
    </Formik>
  );
}
